import { parseReview } from 'Parsers/reviewParser'
import { getCompanyReviews, updateReviewReply, addReviewReply } from 'Api/reviewApi'
import { ratingFilterList, replyFilterList } from 'Services/reviewFilterList'
import { formatReviewFilter } from 'Formatters/reviewFormatter'

const state = {
  requesting: {
    reviews: false,
    reply: false,
  },

  pagination: {
    current: 1,
    limit: 1,
  },

  filters: {
    ratings: [],
    replies: [],
  },

  filterList: {
    ratings: ratingFilterList,
    replies: replyFilterList,
  },

  searchTerm: '',

  reviewList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_review_list(state, reviewList) {
    state.reviewList = reviewList
  },
  set_pagination(state, pagination) {
    state.pagination = pagination
  },
  set_search_term(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  set_rating_filter(state, ratings) {
    state.filters.ratings = ratings
  },
  set_replies_filter(state, replies) {
    state.filters.replies = replies
  },
  reset_filters(state) {
    state.filters.ratings = []
    state.filters.replies = []
  }
}

const actions = {
  async getReviewList({ state, commit }) {
    commit('request_start', 'reviews')

    try {
      const { searchTerm, filters, pagination } = state

      const options = formatReviewFilter(searchTerm, filters)
      const { data } = await getCompanyReviews(pagination.current, options)

      const reviewList = data.items.map(parseReview)
      commit('set_review_list', reviewList)

      commit('set_pagination', { current: data.page, limit: data.pageCount })
      commit('request_success', 'reviews')

      return reviewList
    } catch (err) {
      commit('request_failure', 'reviews')

      throw err
    }
  },

  async searchReview({ commit, dispatch }, query) {
    commit('set_search_term', query)

    try {
      const result = await dispatch('getReviewList')

      return result
    } catch (err) {
      throw err
    }
  },

  async paginate({ state, commit, dispatch }, page) {
    const { pagination } = state
    commit('set_pagination', Object.assign({}, pagination, { current: page }))

    try {
      const result = await dispatch('getReviewList')

      return result
    } catch (err) {
      throw err
    }
  },

  async addReply({ commit, dispatch }, { negotiationId, comment }) {
    commit('request_start', 'reply')

    try {
      const result = await addReviewReply(negotiationId, comment)

      await dispatch('getReviewList')
      commit('request_success', 'reply')

      return result
    } catch (err) {
      commit('request_failure', 'reply')

      throw err
    }
  },

  async editReply({ commit, dispatch }, { replyId, comment }) {
    commit('request_start', 'reply')

    try {
      const result = await updateReviewReply(replyId, comment)

      await dispatch('getReviewList')
      commit('request_success', 'reply')

      return result
    } catch (err) {
      commit('request_failure', 'reply')

      throw err
    }
  },

  toggleRatings({ commit, state }, id) {
    const { filters } = state

    const ratings = filters.ratings.includes(id)
      ? filters.ratings.filter(item => item !== id)
      : [ id, ...filters.ratings ]

    commit('set_rating_filter', ratings)
  },

  toggleReplies({ commit }, id) {
    const { filters } = state

    const replies = filters.replies.includes(id)
      ? filters.replies.filter(item => item !== id)
      : [ id, ...filters.replies ]

    commit('set_replies_filter', replies)
  },

  removeFilters({ commit }) {
    commit('reset_filters')
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}